import {useIsPremiumPage, useIsStoryPage} from '@aboutyou/router';

export const useIsSpecialPageWithoutUspBanner = () => {
  const isStoryRoute = useIsPremiumPage();
  const isPremiumRoute = useIsStoryPage();
  return isStoryRoute || isPremiumRoute;
};
